import { merge } from 'lodash';
import { DefaultTheme } from '../default/wds_theme';

const changes = {
	palette: {
		name: 'Admin',
		primary: {
			main: '#05467E',
			contrast: '#FFFFFF',
			hover: '#507CB6',
			pressed: '#3081C0',
		},
		success: {
			main: '#00BF6F',
			contrast: '#FFFFFF',
			hover: '#009E5C',
			pressed: '#009E5C',
		},
		muted: {
			main: '#D0D2D3',
			contrast: '#393939',
		},
	},
};

export const AdminTheme = merge({}, DefaultTheme, changes);
